module.exports = __webpack_public_path__ + "img/brands-barilla-header.jpg?1f9d5a1dce69da4d2913e87163377fb3";